import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../../chunks/tslib.es6.js";
import { JSONMap as r } from "../../core/jsonMap.js";
import { JSONSupport as e } from "../../core/JSONSupport.js";
import { property as t } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
var s = new r({
  esriFeatureEditToolAutoCompletePolygon: "auto-complete-polygon",
  esriFeatureEditToolCircle: "circle",
  esriFeatureEditToolEllipse: "ellipse",
  esriFeatureEditToolFreehand: "freehand",
  esriFeatureEditToolLine: "line",
  esriFeatureEditToolNone: "none",
  esriFeatureEditToolPoint: "point",
  esriFeatureEditToolPolygon: "polygon",
  esriFeatureEditToolRectangle: "rectangle",
  esriFeatureEditToolArrow: "arrow",
  esriFeatureEditToolTriangle: "triangle",
  esriFeatureEditToolLeftArrow: "left-arrow",
  esriFeatureEditToolRightArrow: "right-arrow",
  esriFeatureEditToolUpArrow: "up-arrow",
  esriFeatureEditToolDownArrow: "down-arrow"
});

var l = /*#__PURE__*/function (_e) {
  _inherits(l, _e);

  var _super = _createSuper(l);

  function l(o) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, o), _this.name = null, _this.description = null, _this.drawingTool = null, _this.prototype = null, _this.thumbnail = null;
    return _this;
  }

  return l;
}(e);

o([t({
  json: {
    write: !0
  }
})], l.prototype, "name", void 0), o([t({
  json: {
    write: !0
  }
})], l.prototype, "description", void 0), o([t({
  json: {
    read: s.read,
    write: s.write
  }
})], l.prototype, "drawingTool", void 0), o([t({
  json: {
    write: !0
  }
})], l.prototype, "prototype", void 0), o([t({
  json: {
    write: !0
  }
})], l.prototype, "thumbnail", void 0), l = o([i("esri.layers.support.FeatureTemplate")], l);
var a = l;
export { a as default };